import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ElementRef,
  ViewEncapsulation,
} from "@angular/core";
import { IUProperty } from "src/app/shared/interface/umbraco-property";
import { IPictureData } from "../../shared/components/picture/picture.component";
import { applyTitleSettings } from "../../shared/utils/title-style-settings-utils";
import { ITitleStyleSettings } from "../../shared/interface/title-style-settings";

interface ISidescrollingLogosPanelData {
  title?: IUProperty<string>;
  logos?: IUProperty<IPictureData[]>;
  numberOfRows?: IUProperty<string>;
  grayscaleLogos?: IUProperty<boolean>;
  backgroundColor?: IUProperty<string>;
  titleStyleSettings?: ITitleStyleSettings;
}

@Component({
  selector: "app-sidescrolling-logos-panel",
  templateUrl: "./sidescrolling-logos-panel.component.html",
  styleUrls: ["./sidescrolling-logos-panel.component.less"],
  encapsulation: ViewEncapsulation.None,
})
export class SidescrollingLogosPanelComponent implements OnInit {
  @Input() data: ISidescrollingLogosPanelData;

  numberOfRows: number = 1;
  logoRows: IPictureData[][] = [];

  @ViewChild("titleEl", { static: false }) titleEl: ElementRef<HTMLElement>;
  @ViewChild("panelEl", { static: false }) panelEl: ElementRef<HTMLElement>;
  @ViewChild("wrapperEl", { static: false }) wrapperEl: ElementRef<HTMLElement>;

  ngOnInit() {
    this.setNumbersOfRowsFromSettings(this.data.numberOfRows);
    this.mapLogosToRows(this.data.logos.value);
  }

  ngAfterViewInit() {
    applyTitleSettings(this.data, this.titleEl);

    if (this.data.backgroundColor && this.data.backgroundColor.value) {
      this.panelEl.nativeElement.style.setProperty(
        "--sidescrolling-logos-panel-bg-color",
        this.data.backgroundColor.value
      );
    }
  }

  setNumbersOfRowsFromSettings(numberOfRows: IUProperty<string>) {
    if (numberOfRows && numberOfRows.value) {
      this.numberOfRows = parseInt(numberOfRows.value || "1", 10);
    }
  }

  mapLogosToRows(logos: IPictureData[]) {
    if (!logos && logos.length === 0) return;

    // creating a slider rows depending on number of rows in panel settings
    this.logoRows = Array.from({ length: this.numberOfRows }, () => []);

    // separating logos to rows
    for (let i = 0; i < logos.length; i++) {
      const rowIndex = i % this.numberOfRows;
      this.logoRows[rowIndex].push(logos[i]);
    }
  }
}
